export const MANUAL_URLS = {
  BACK: 'Back',
};
